import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {ConfirmationButtonComponent} from './confirmation-button.component';
import {ButtonModule} from '../../../../modules/core/component/button/button.module';
import {ConfirmationButtonDialogModule} from './confirmation-button-dialog/confirmation-button-dialog.module';

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        ButtonModule,
        ConfirmationButtonDialogModule,
    ],
    declarations: [
        ConfirmationButtonComponent,
    ],
    exports: [
        ConfirmationButtonComponent,
    ],
})
export class ConfirmationButtonModule {}
